import classnames from 'classnames';
import React from 'react';

import { CheckboxLabelProps } from './types';

export const CheckboxLabel: React.FC<CheckboxLabelProps> = ({ label, sublabel, infoButton, externalLinkLabel }) => (
    <>
        <legend>
            <div
                className={classnames('sgw-checkbox-legend', {
                    'sgw-checkbox-legend__with-sublegend': sublabel !== undefined,
                })}
            >
                {typeof label === 'string' ? <span className="sgw-checkbox-legend-text">{label}</span> : label}
                {infoButton && !sublabel && infoButton}
            </div>
            {sublabel && (
                <p className="sgw-checkbox-sublegend">
                    <span className="sgw-checkbox-sublegend-text">{sublabel}</span>
                    {infoButton}
                </p>
            )}
        </legend>
        {externalLinkLabel && <div className="sgw-checkbox__external-link-label">{externalLinkLabel}</div>}
    </>
);
